export default "__VITE_ASSET__PJPZoV4x__"